
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("9dU2w", function(module, exports) {

$parcel$export(module.exports, "WatchDialogWrapper", () => $6b70cc4500c483ce$export$a4de2aef32c151a8);

var $gwFzn = parcelRequire("gwFzn");

var $fppBw = parcelRequire("fppBw");

var $bzo9I = parcelRequire("bzo9I");
class $6b70cc4500c483ce$export$a4de2aef32c151a8 extends (0, $gwFzn.PureComponent) {
    render() {
        const { contentId: contentId, defaultTab: defaultTab, componentLocation: componentLocation, isDisabled: isDisabled } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bzo9I.WatchDialog), {
            contentId: contentId,
            defaultTab: defaultTab,
            customPlacement: "bottom",
            onRender: this.buttonRendered,
            componentLocation: componentLocation,
            isDisabled: isDisabled
        });
    }
}
$6b70cc4500c483ce$export$a4de2aef32c151a8.propTypes = {
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).string.isRequired,
    defaultTab: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).number.isRequired,
    componentLocation: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).number,
    isDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).bool
};

});


//# sourceMappingURL=WatchDialogWrapper.2c3e0c0e.js.map
